import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./AddDocument.module.scss";
import { CloseIcon } from "Assets/icons";
import { Formik } from "formik";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import { MIME_TYPES } from "config/constants";
import { cloneDeep } from "lodash";
import attachDocumentSchema from "./addForm";

const AddDocumentPop = ({ show, setShow, handleSubmit }) => {

    const handlePopup = () => setShow(!show);

    const handleAttachDocument = (name, values, prevValues = [], setFieldValue) => {
        try {
            let cloneValues = cloneDeep(prevValues);
            values?.map(i => cloneValues.push({ attachment_key: i, attachment_name: i }))
            setFieldValue(name, cloneValues);
        }
        catch (err) { console.error("Failed to attach document", err); }
    };

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <Button
                        onClick={handlePopup}
                        className="border-0 p-0 position-absolute"
                        variant="transparent"
                        style={{ right: 10, top: 0 }}
                    >
                        <CloseIcon />
                    </Button>
                    <div>
                        <h6 className="m-0 fw-bold themeBlue">Add Attachment</h6>

                    </div>
                    <Row>
                        <Col className="col-12 my-2">
                            <div className="iconWithText position-relative">
                                <Formik
                                    initialValues={{ documents: [] }}
                                    validationSchema={attachDocumentSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {
                                        ({
                                            handleSubmit,
                                            isSubmitting,
                                            values,
                                            errors,
                                            setFieldValue,
                                        }) => (
                                            <Form onSubmit={handleSubmit}>
                                                {console.log("errrrorrsss", errors)}
                                                <Row>
                                                    <Col md="12" sm="12" className="my-2">

                                                        <AppFileUploadField
                                                            name="documents"
                                                            acl={"private"}
                                                            accept="image/*, application/pdf, .doc, .docx"
                                                            allowedTypes={[MIME_TYPES.pdf, MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.webp, MIME_TYPES.doc, MIME_TYPES.docx]}
                                                            className={`${styles.formControl} form-control`}
                                                            onChange={(name, value) => {
                                                                handleAttachDocument(name, value, values?.documents, setFieldValue);
                                                            }}
                                                            multiple
                                                        />
                                                    </Col>
                                                    <Col md="12" sm="12" className="my-2 d-flex justify-content-center">
                                                        <Button
                                                            type="submit"
                                                            className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                                        >
                                                            Save

                                                        </Button>

                                                    </Col>
                                                </Row>
                                            </Form>
                                        )}
                                </Formik>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default AddDocumentPop;